import React, { useState } from "react";
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  PinterestShareButton,
  TelegramShareButton,
  EmailShareButton,
  FacebookIcon,
  LinkedinIcon,
  TwitterIcon,
  WhatsappIcon,
  PinterestIcon,
  TelegramIcon,
  EmailIcon,
} from "react-share";
import {
  FaInstagram,
  FaYoutube,
  FaTiktok,
  FaSnapchat,
  FaReddit,
  FaTumblr,
  FaQuora,
  FaFacebookMessenger,
} from "react-icons/fa";
import { FaWhatsapp, FaTelegram, FaEnvelope } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

const SharePopup = ({ shareUrl, heading, data, shareText, onClose, id }) => {
  const [showAll, setShowAll] = useState(false);


  return (
    <div
      className="position-fixed top-50 start-50 translate-middle bg-white p-4 rounded-4 shadow-lg"
      style={{
        zIndex: 3000,
        width: "350px",
        textAlign: "center",
        animation: "fadeIn 0.3s ease-in-out",
      }}
    >

      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0 fw-bold">Share</h5>
        <button className="btn-close" onClick={onClose}></button>
      </div>


      <div className="d-flex flex-wrap justify-content-center gap-3 mb-3">
        {/* <a
          onClick={() => {
            const shareUrl = `https://dev-service.asraimmigration.ca/backend_service/v1/shareBlog/${id}`;

            navigator.clipboard.writeText(shareUrl).then(() => {
              const shouldOpen = window.confirm('Link copied! Would you like to open Instagram to share it?');
              if (shouldOpen) {
                window.open('https://www.instagram.com/', '_blank');
              }
            });
          }}
          style={{ cursor: 'pointer' }}
        >
          <FaInstagram size={45} color="#E4405F" />
        </a> */}
        <a
          href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
            `https://dev-service.asraimmigration.ca/backend_service/v1/linkedIn/${id}`
          )}`}
          target="_blank"
        >

          <LinkedinIcon size={45} round />
        </a>


        {/* <a href="https://www.youtube.com/" target="_blank" rel="noopener noreferrer">
          <FaYoutube size={45} color="#FF0000" />
        </a> */}

        <a
          href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
            `https://dev-service.asraimmigration.ca/backend_service/v1/shareFacebook/${id}`
          )}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <FacebookIcon size={45} round />
        </a>
        <a
          href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(
            `https://dev-service.asraimmigration.ca/backend_service/v1/shareBlog/${id}`
          )}&text=${encodeURIComponent("Check out this blog!")}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaXTwitter size={45} round color="black" />
        </a>
        <a
          href={`https://wa.me/?text=${encodeURIComponent(
            `Check out this blog: ${heading}\n\n` +
            `https://dev-service.asraimmigration.ca/backend_service/v1/shareWhatsapp/${id}?t=${Date.now()}`
          )}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaWhatsapp size={45} color="#25D366" />
        </a>


        <PinterestShareButton
          url={`https://dev-app.asraimmigration.ca/newsspecialcontent/${id}`}
          media={data?.blog_image}
          description={heading}
        >
          <PinterestIcon size={45} round />
        </PinterestShareButton>
        {/* <a href="https://www.tiktok.com/" target="_blank" rel="noopener noreferrer">
          <FaTiktok size={45} color="#000000" />
        </a> */}
      </div>

      {showAll && (
        <div className="d-flex flex-wrap justify-content-center gap-3 mb-3">
          <a
            href={`https://t.me/share/url?url=${encodeURIComponent(
              `https://dev-app.asraimmigration.ca/newsspecialcontent/${id}`
            )}&text=${encodeURIComponent(shareText)}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaTelegram size={45} color="#0088cc" />
          </a>


          <a
            href={`https://mail.google.com/mail/?view=cm&fs=1&su=${encodeURIComponent(
              heading
            )}&body=${encodeURIComponent(
              `Check out this blog:\n\nhttps://dev-service.asraimmigration.ca/backend_service/v1/shareBlog/${id}`
            )}`}
            target="_blank"
          >
            <FaEnvelope size={45} />
          </a>



          {/* <a href="https://www.snapchat.com/" target="_blank" rel="noopener noreferrer">
            <FaSnapchat size={45} color="#FFFC00" />
          </a> */}

          <a
            href={`https://www.reddit.com/submit?url=${encodeURIComponent(
              `https://dev-service.asraimmigration.ca/backend_service/v1/shareBlog/${id}`
            )}&title=${encodeURIComponent(shareText)}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaReddit size={45} color="#FF4500" />
          </a>


          <a
            href={`https://www.tumblr.com/widgets/share/tool?canonicalUrl=${encodeURIComponent(
              `https://dev-service.asraimmigration.ca/backend_service/v1/shareBlog/${id}`
            )}&title=${encodeURIComponent(shareText)}&caption=${encodeURIComponent(
              heading
            )}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaTumblr size={45} color="#36465D" />
          </a>

          {/* <a
            href={`https://www.quora.com/share?url=${encodeURIComponent(
              `https://dev-service.asraimmigration.ca/backend_service/v1/shareBlog/${id}`
            )}&title=${encodeURIComponent(shareText)}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaQuora size={45} color="#B92B27" />
          </a> */}



          <a
            href={`https://www.facebook.com/dialog/send?app_id=YOUR_APP_ID&link=${encodeURIComponent(`https://dev-service.asraimmigration.ca/backend_service/v1/shareMessenger/${id}`)}&redirect_uri=${encodeURIComponent(`https://dev-app.asraimmigration.ca/newsspecialcontent/${id}`)}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaFacebookMessenger size={45} color="#0084FF" />
          </a>
        </div>
      )}


      <button
        className="btn btn-outline-primary btn-sm"
        onClick={() => setShowAll(!showAll)}
      >
        {showAll ? "Less" : "More"}
      </button>
    </div>
  );
};

export default SharePopup;
